import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import LegalServicesModal from './LegalServicesModal';

const LegalServicesModalDemo = () => {
  const [showLegalServicesModal, setShowLegalServicesModal] =
    React.useState<boolean>(false);

  const handleShowLegalServicesModal = () => setShowLegalServicesModal(true);
  const handleCloseLegalServicesModal = () => setShowLegalServicesModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Legal Services Modal</h4>
        <Button onMouseDown={handleShowLegalServicesModal}>Open Modal</Button>
        <LegalServicesModal
          showLegalServicesModal={showLegalServicesModal}
          handleCloseLegalServicesModal={handleCloseLegalServicesModal}
        />
      </Container>
    </Container>
  );
};

export default LegalServicesModalDemo;
